import React from "react";
import { render } from "react-dom";
import assertContainerElement from "Utils/assertContainerElement";
import WorkplaceSearchForm from "./Components/WorkplaceSearchForm";
import OverviewVideoModal from "./Components/OverviewVideoModal";
import ResourcesSection from "./Components/ResourcesSection";
import "Styles/Pages/hp3.scss";
import { BlockedUserModal } from "Pages/Components/BlockedUserModal";
import initReveal from "./initReveal";
import initCtaSwoop from "./initCtaSwoop";
import initCarousel from "./initCarousel";
import initWorkspacesCarousel from "./initWorkspacesCarousel";

// ---- search input ----
const searchFormRoot = document.getElementById("hp3-hero-search");
assertContainerElement(searchFormRoot);
render(<WorkplaceSearchForm />, searchFormRoot); 

// ---- workspace carousel ----
initWorkspacesCarousel();

// ---- platform overview video ----
const videoModalRoot = document.getElementById("hp3-video-modal");
assertContainerElement(videoModalRoot);
render(<OverviewVideoModal triggerId="hp3-video-button" />, videoModalRoot);

// ---- testimonials ----
initCarousel("#hp3-testimonials-swiper", { loop: true, gap: { mobile: 16, desktop: 24 } });

// ---- resources ----
const resourcesRoot = document.getElementById("hp3-resources");
assertContainerElement(resourcesRoot);
render(<ResourcesSection />, resourcesRoot);

// ---- animations ----
initReveal();
initCtaSwoop("hp3-cta-card");

// ---- block user ----

const blockedUserModalRoot = document.getElementById("blocked-user-modal");
assertContainerElement(blockedUserModalRoot);
const blockedUserTypeString = blockedUserModalRoot.dataset["type"];
const blockedUserType = blockedUserTypeString == LSCommon.Models.BlockedUserMessageType.Blocked
   ? LSCommon.Models.BlockedUserMessageType.Blocked
   : blockedUserTypeString == LSCommon.Models.BlockedUserMessageType.Locked
      ? LSCommon.Models.BlockedUserMessageType.Locked
      : LSCommon.Models.BlockedUserMessageType.None;
const blockedUserModalFirstName = blockedUserModalRoot.dataset["firstName"]!;

render(<BlockedUserModal type={blockedUserType} firstName={blockedUserModalFirstName} />, blockedUserModalRoot);
